import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';
import { Button } from '../ui/button';

export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // Small delay to show after page load
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    setIsVisible(false);
  };

  const handleConfigure = () => {
    // For now, just accept - could open a modal in the future
    localStorage.setItem('cookie-consent', 'configured');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
          data-testid="cookie-banner"
        >
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-brand-lg border border-brand-sage/30 p-6">
            <div className="flex items-start gap-4">
              <div className="p-2 bg-brand-sage/20 rounded-full">
                <Cookie className="w-6 h-6 text-brand-primary" />
              </div>
              <div className="flex-1">
                <h3 className="font-manrope font-bold text-lg text-text-primary mb-2">
                  Utilizamos cookies
                </h3>
                <p className="text-text-secondary text-sm mb-4">
                  Usamos cookies propias y de terceros para mejorar tu experiencia, analizar el tráfico 
                  y personalizar contenido. Puedes aceptar todas, rechazarlas o configurar tus preferencias.
                </p>
                <div className="flex flex-wrap gap-3">
                  <Button
                    onClick={handleAccept}
                    className="btn-primary text-sm py-2 px-4"
                    data-testid="cookie-accept-btn"
                  >
                    Aceptar todas
                  </Button>
                  <Button
                    onClick={handleReject}
                    variant="outline"
                    className="btn-outline text-sm py-2 px-4"
                    data-testid="cookie-reject-btn"
                  >
                    Rechazar
                  </Button>
                  <Button
                    onClick={handleConfigure}
                    variant="ghost"
                    className="text-text-secondary hover:text-brand-primary text-sm py-2 px-4"
                    data-testid="cookie-configure-btn"
                  >
                    Configurar
                  </Button>
                </div>
              </div>
              <button
                onClick={handleReject}
                className="p-1 hover:bg-brand-sage/20 rounded-full transition-colors"
                aria-label="Cerrar"
                data-testid="cookie-close-btn"
              >
                <X className="w-5 h-5 text-text-muted" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
